import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isMobile, isTablet } from 'react-device-detect';

import { DeviceDetectContext } from './context';

export class DeviceDetectProvider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMobile,
      isTablet,
    };
  }

  render() {
    const { children } = this.props;
    const { isMobile, isTablet } = this.state;

    return (
      <DeviceDetectContext.Provider value={{ isMobile, isTablet }}>
        {children}
      </DeviceDetectContext.Provider>
    );
  }
}

DeviceDetectProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export default DeviceDetectProvider;
